import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export const notificarPublicacaoAnuncioService = async (id: number) => {
  const Token = validateToken();

  if (!Token) {
    throw new Error("Token inválido ou expirado.");
  }

  const URL = `${Globais.DOMINIOBACK}/anuncio-propriedade/${id}/notificar-publicacao`;
  const response = await axios.post(URL, {}, {
    headers: { Authorization: Token.AuthStr },
  });

  if (response.data?.success === false || response.data?.sucesso === false) {
    throw new Error(
      response.data?.message ||
        response.data?.mensagem ||
        "Não foi possível enviar a mensagem de publicação."
    );
  }

  return response.data;
};
